module.exports = __webpack_public_path__ + "img/3.c3b6eb6b.jpg";